import React from "react";


//just a loading screen no jsx added as it was showing like a flicker
function LoadingScreen() {
  return <div className="loading-container"></div>;
}

export default LoadingScreen;
